export default "__VITE_ASSET___xgxg$BZ__"